import { VISUAL_02 } from "../../data/reportContent";

export const Visual02 = () => (
  <section id={VISUAL_02.id} className="visual-block" data-testid="visual-02-section">
    <div className="visual-head">
      <span className="report-kicker">{VISUAL_02.number}</span>
      <h2>{VISUAL_02.title}</h2>
      <p>{VISUAL_02.intro}</p>
    </div>

    <div className="v2-table-wrap" data-testid="visual-02-table">
      <table className="v2-table">
        <thead>
          <tr>
            {VISUAL_02.columns.map((c) => (
              <th key={c}>{c}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {VISUAL_02.rows.map((row, i) => (
            <tr key={i}>
              {row.map((cell, j) => (
                <td key={j} data-label={VISUAL_02.columns[j]}>
                  {cell}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    <p className="visual-note">{VISUAL_02.note}</p>
  </section>
);
